var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0c55.23 0 100 44.773 100 100S155.224 200 99.997 200C44.773 200 0 155.227 0 100S44.773 0 100 0Zm63.489 108.316H36.51c0 36.4 28.424 65.91 63.486 65.91 35.065 0 63.492-29.51 63.492-65.91Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    fill: "#FFF",
    d: "M27.15 62.057h146.738v61.41H27.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.976 108.68c-1.243-13.136-4.388-36.548-6.304-43.426a28.474 28.474 0 0 0-1.107-3.238c-2.548-6.243-7.066-10.177-15.519-12.396-9.334-2.446-22.318-7.602-69.85-7.602s-60.517 5.156-69.843 7.602C21.9 51.84 17.38 55.773 14.83 62.016a29.49 29.49 0 0 0-1.106 3.238C11.8 72.132 8.66 95.544 7.417 108.68c-.234 2.446-.399 4.538-.479 6.096-.508 9.931 1.687 14.17 8.08 18.419 4.164 2.765 7.996 5.323 14.79 8.484 6.795 3.157 15.093 6.998 24.209 6.998 5.698 0 24.46-3.78 31.366-4.951 4.492-.762 10.551-1.192 14.813-1.192 4.261 0 10.32.43 14.814 1.192 6.906 1.172 25.668 4.951 31.366 4.951 9.116 0 17.414-3.841 24.208-6.998 6.793-3.16 10.628-5.72 14.784-8.484 6.397-4.25 8.59-8.488 8.085-18.419-.08-1.561-.245-3.65-.477-6.096Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 111.79V68.21c0-1.192.421-2.192 1.263-3 .842-.806 1.825-1.21 2.948-1.21.35 0 .719.053 1.105.158a4.38 4.38 0 0 1 1.105.474l34.316 21.79a4.074 4.074 0 0 1 1.42 1.578c.317.632.475 1.298.475 2s-.158 1.368-.474 2a4.074 4.074 0 0 1-1.421 1.579l-34.316 21.79c-.35.21-.72.368-1.105.473a4.2 4.2 0 0 1-1.105.158c-1.123 0-2.106-.404-2.948-1.21-.842-.808-1.263-1.808-1.263-3Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.524eea67735b3a1c1029e0866612592e.svg";
export { ForwardRef as ReactComponent };